import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Modal from 'reactstrap/lib/Modal';
import ModalBody from 'reactstrap/lib/ModalBody';
import Button from 'reactstrap/lib/Button';
import { EventToolbox } from 'client/utils/event-toolbox';
import { TrackingConstant } from 'client/tracking/constant';
import { PRICE_CHECKER_CREATIVE_ID } from 'site-modules/shared/constants/price-checker';
import { Link } from 'site-modules/shared/components/link/link';
import { URL_PATHS } from 'site-modules/shared/constants/appraisal/paths';

import './go-to-appraise-modal.scss';

export function GoToAppraiseModalUI({ appraisalLink = URL_PATHS.APPRAISAL_LANDING, isOpen, toggle }) {
  useEffect(() => {
    if (!isOpen) {
      return;
    }

    EventToolbox.fireTrackAction({
      event_type: TrackingConstant.EVENT_TYPE_WIDGET_VIEW,
      event_data: {
        action_name: TrackingConstant.EVENT_TYPE_WIDGET_VIEW,
        subaction_name: 'price_checker_used_popup',
        action_category: TrackingConstant.SYSTEM_ACTION_CATEGORY,
        action_cause: TrackingConstant.SYSTEM_ACTION_CAUSE,
        creative_id: PRICE_CHECKER_CREATIVE_ID,
      },
    });
  }, [isOpen]);

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalBody
        className="go-to-appraise-modal px-2 py-1_5 px-md-3_5 py-md-2_5"
        data-tracking-parent={PRICE_CHECKER_CREATIVE_ID}
      >
        <Button
          color="link"
          size="lg"
          className="modal-close-btn p-0_25 text-decoration-none"
          aria-label="Close"
          onClick={toggle}
        >
          <i className="icon-cross2 size-16" aria-hidden />
        </Button>
        <div className="text text-gray-darker">
          We need additional information like mileage and condition for accurate used pricing.
        </div>
        <div className="text text-gray-darker mb-1_5">Continue to Edmunds used car appraiser.</div>
        <Button
          tag={Link}
          to={appraisalLink}
          color="primary-b"
          size="lg"
          className="submit-btn text-transform-none px-2_5 py-0_5 text-white"
          data-tracking-id="pc_go_to_appraiser"
        >
          Appraise a used car
        </Button>
      </ModalBody>
    </Modal>
  );
}

GoToAppraiseModalUI.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  appraisalLink: PropTypes.string,
};

export const GoToAppraiseModal = React.memo(GoToAppraiseModalUI);
